export default [

     {
          path: '/disaster-recovery-plan-site',
          name: 'DisasterRecoveryPlanSite',
          component: () => import("@/views/Page/DisasterRecoveryPlanSite/DisasterRecoveryPlanSite.vue"),
          meta: {
               title: 'Disaster Recovery Plan Site',
          },
     }
];